<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <logo />
        </b-link>

        <b-card-title class="mb-1 text-center">
          {{ t('Enter Your New Password') }}
        </b-card-title>

        <!--Login form -->
        <validation-observer ref="resetPasswordForm">
          <b-form class="auth-login-form mt-2" @submit.prevent="resetPassword">
            <b-form-group>
              <div class="d-flex form-group-label">
                <label for="password">{{ t('New Password') }}</label>
                <span class="text-danger">*</span>
              </div>
              <validation-provider
                #default="{ errors }"
                :name="t('Password')"
                rules="required|uppercase_and_digit|min:6"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="newPassword"
                    v-model="newPassword"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="newPassword"
                    :placeholder="t('New Password')"
                    tabindex="5"
                    autocomplete="off"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button variant="primary" type="submit" block :disabled="submitting">
              {{ submitting ? t('Loading') : t('Reset My Password') }}
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue';
import Logo from '@core/layouts/components/Logo.vue';
import { required, email } from '@validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us';

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    Logo,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver
  },

  mixins: [togglePasswordVisibility, helper],

  data() {
    return {
      newPassword: '',

      // validation rules
      required,
      email,
      submitting: false
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  },

  methods: {
    resetPassword() {
      this.$refs.resetPasswordForm.validate().then(success => {
        if (success) {
          this.submitting = true;

          useService
            .resetPassword({
              token: this.$route.query.token,
              newPassword: this.newPassword
            })
            .then(response => {
              this.$router.push('/login');
              this.showSuccessMessage(
                `${response.message || this.$t('Reset Password Success Message')}`
              );
            })
            .catch(messages => {
              if (typeof messages === 'object' && messages && messages.length) {
                messages.forEach(item => {
                  this.showErrorMessage(item.message);
                });
              }
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
